import styled from "styled-components";

export const ContentWrapper = styled.div`
    width               : 100%
    height              : 100%
`